<template>
  <div v-if="isLoggedIn && checkSbwShowOnce">
    <div v-if="isLoadingWidgetAPI">
      <!-- shimmer here -->
    </div>
    <div v-else-if="getWidgetData?.length">
      <div v-if="checkBoostAvail">
        <Observer :options="{ rootMargin: '-50px' }" @intersect="itisvisible" />
        <div v-for="(childItem, i) in getWidgetData" :key="i">
          <!-- non enrolled user -->
          <div
            v-if="
              (!getUserData.isEnrolled && childItem?.props?.isEnrolled == 'false')
            "
            class="sliding-banner-widget"
            :class="{ 'along-checkout': cartQuantity > 0 }"
            :style="getWrapStyles(childItem?.props)"
            @click="enrollUser($event)"
          > 
            <div class="flex-row align-items-center pr">
              <span class="cancel-sbw" @click.stop="closeSbw()">
                <img :src="childItem?.image1" />
              </span>
              <div
                class="banner-title medium multi-line-ellipses-v2 mr5"
                v-html="getTitle(childItem?.title)"
              ></div>
              <button
                v-if="childItem?.props?.ctaText"
                class="btn medium fs-12 pt5 pb5 pr5 pl5"
              >
                {{ childItem?.props?.ctaText }}
              </button>
            </div>

          </div>

          <!-- already enrolled user -->
          <div
            v-if="
              (getUserData.isEnrolled && childItem?.props?.isEnrolled == 'true')
            "
            class="sliding-banner-widget"
            :class="{ 'along-checkout': cartQuantity > 0 }"
            :style="getWrapStyles(childItem?.props)"
          >
            <div class="flex-row align-items-center pr">
              <span class="cancel-sbw" @click="closeSbw()">
                <img :src="childItem?.image1" />
              </span>
              
              <div
                class="banner-title medium multi-line-ellipses-v2"
                v-html="getTitle(childItem?.title)"
              ></div>
              <button
                v-if="childItem?.props?.ctaText"
                class="btn medium fs-12 pt5 pb5 pr5 pl5"
              >
                {{ childItem?.props?.ctaText }}
              </button>
            </div>
          </div>

          <!-- enroll now modal -->
          <generic-modal
            v-if="showWidgetModal && !getUserData.isEnrolled && childItem?.props?.isEnrolled == 'false'"
            @close="closeWidgetModal()"
            :height="widgetModalDim.height"
            :width="widgetModalDim.width"
            :animationStyle="widgetModalDim.animationStyle"
            :modalClass="widgetModalDim.modalClass"
          >
            <template v-slot:header> </template>
            <template v-slot:body>
              <!-- enrolling process -->
              <div v-if="isLoading" class="flex-column align-items-center">
                <div class="reward-logo">
                  <img 
                    class="reward-img"
                    :src="staticImgBaseUrl + '/images/global/rewards/cheesy-rewards-logo.svg'"
                    width="56"
                    height="56"
                  />
                </div> 
                <div class="loader-msg">{{childItem?.props?.enrollingText}}</div>
              </div>

              <!-- enrollment done -->
              <div v-if="!isLoading" class="flex-column align-items-center">
                <div v-if="isEnrollmentSuccess">
                  <div class="reward-logo">
                    <div class="lottie-confetti"                     
                      width="56"
                      height="56">
                      <VueLottiePlayer
                        name="confettiAnim"
                        width="100%"
                        height="100%"
                        :loop="true"
                        :animationData="require(`../assets/enroll_success.json`)"
                      />
                    </div>
                  </div> 
                  <div class="loader-msg">{{childItem?.props?.enrolledText}}</div>
                </div>
                <div v-if="!isEnrollmentSuccess" class="enroll-error-container">
                  <img 
                    :src="staticImgBaseUrl + '/images/global/rewards/alert-icon.svg'"
                  />
                  <p>
                    {{ retryCount < 2 ? childItem?.props?.enrollErrorMsg : 'Oops!' }}
                    <span 
                      v-if="retryCount >= 2" 
                      v-html="finalErrorText"
                    ></span>
                  </p>
                  <button @click="tryAgain()" class="btn medium fs-14 pt10 pb10 pr10 pl10">
                    {{ retryCount < 2 ? 'Try Again' : 'Ok' }}
                  </button>
                </div>
              </div>

            </template>
            <template v-slot:footer>
              <div></div>
            </template>
          </generic-modal>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Utility from "../helpers/utility";
import { keyMapsAction, keyMapsGetter, keyMapsMutation } from "../helpers/storeKeys";
import GenericModal from "./GenericModal.vue";
import PageNames from "../config/pageNames";

import {
  staticImgBaseUrl,
  v2PwaBasePath,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import setEvents from "../helpers/events";
import Observer from "../assets/Observer.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";

export default {
  name: "SlidingBannerWidget",
  props: ["dataApi", "moduleProps"],
  components: {
    GenericModal,
    Observer,
  },
  data() {
    return {
      staticImgBaseUrl,
      modulePropsData: {},
      sbwShowOnce: false,
      widgetType: "",
      widgetSubType: "",
      showWidgetModal: false,
      widgetModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "sliding-widget-modal",
      },
      retryCount: 0,
      finalErrorText: "We are facing some issue at the moment.<br>Please try again later.",
      isUpdated: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.widgetType = this.modulePropsData?.type || "";
    this.widgetSubType = this.modulePropsData?.subType || "";
    if (!Utility.getSessionStorageValue("showSlidingBanner")) {
      this.sbwShowOnce = true;
    }
  },
  methods: {
    itisvisible() {
      setTimeout(() => {
        if(!this.isUpdated && this.getWidgetData?.length) {
          this.eventFunEnrolling(false, { Page_Name: PageNames.NEXTGEN_MENUPAGE, Previous_page: PageNames.NEXTGEN_HOMEPAGE });
          this.isUpdated = true;
        }
      }, 500);
    },
    getWrapStyles(modProps) {
      let bg = modProps?.background;
      let borderRad = modProps?.borderRadius;
      let bgFilter = modProps?.backdropFilter;
      let elemStyles = {
        background: bg,
        borderRadius: borderRad,
        backdropFilter: bgFilter,
      };
      return elemStyles;
    },
    getTitle(title) {
      return Utility.getProcessedString(title, this.getUserData?.boostWeekRes);
    },
    triggerWidgetModal() {
      document.body.classList.add("body-stop-scroll-mobile");
      this.showWidgetModal = true;
    },
    closeWidgetModal() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showWidgetModal = false;
    },
    eventFunEnrolling(isClicked = false, eObj = {}) {
      if (this.getUserData?.rewardType == "CHEESY") {
        let preEventObj = {};
        let multiplierVal = this.checkBoostAvail ? this.checkBoostAvail: '';
        if (!this.getUserData?.isEnrolled) {
          preEventObj = {
            category: "cheesy rewards",
            subCategory: "enroll now", 
            Event_Label: "POTP2",
            Event_Action: "ClickEnroll",
            aggregatorFlow: "false",
            POTP_Programme_Type: "POTP2",
            rewardsProgramme: `${multiplierVal}x Cheesy Rewards`,
            ...eObj,
          };
        }

        let eventType = isClicked ? "ClickEnroll" : "CR_Impression";
        let userAction = isClicked ? "Click" : "Impression";
        const eventObj = Utility.amplitudeEventObj(
          userAction, 
          "menu enrollment strip", 
          "", 
          preEventObj
        );
        setEvents("amplitude", eventType, eventObj);
      }
    },
    eventFunEnrolled(isClicked = false, eObj = {}) {
      if (this.getUserData?.rewardType == "CHEESY") {
        let preEventObj = {};
        let multiplierVal = this.checkBoostAvail ? this.checkBoostAvail: '';
        preEventObj = {
          category: "cheesy rewards",
          subCategory: "enrolled",
          Event_Label: "loyalty_enroll",
          Event_Category: "Enrollment",
          Event_Action: "enroll_now_click",
          aggregatorFlow: "false",
          POTP_Programme_Type: "POTP2",
          rewardsProgramme: `${multiplierVal}x Cheesy Rewards`,
          ...eObj,
        };  
        
        let eventType = isClicked ? "Programme_enroll" : "CR_Impression";
        let userAction = isClicked ? "Click" : "Impression";
        const eventObj = Utility.amplitudeEventObj(
          userAction, 
          "menu enrollment strip", 
          "", 
          preEventObj
        );
        setEvents("amplitude", eventType, eventObj);
      }
    },
    enrollUser(event) {
      this.eventFunEnrolling(true, { Page_Name: PageNames.NEXTGEN_MENUPAGE, Previous_page: PageNames.NEXTGEN_HOMEPAGE });
      this.triggerWidgetModal();
      let userData = LocalStorageFunc.getUserData()?.userData;
      if(userData && typeof(userData) === "string"){
       userData = Utility.decryptData(userData);
      }
      this.$store.commit(
        keyMapsMutation.UPDATE_LOYALTY_ENROLL_LOADER,
        true
      );
      setTimeout(() => {
        this.$store.dispatch(keyMapsAction.REGISTER_LOYALITY_API, {
          loyaltyCardCode: "POTP2",
          mobile: ((userData?.mobile) ? userData.mobile : ""),
        });
      }, 1000);

      setTimeout(() => {
        if(this.isEnrollmentSuccess) {
          this.eventFunEnrolled(true, { Page_Name: PageNames.NEXTGEN_MENUPAGE, Previous_page: PageNames.NEXTGEN_HOMEPAGE });
          this.$store.dispatch(keyMapsAction.LOYALITY_API);
        }
      }, 3000);
      
    },
    eventFunCloseSbw(isClicked = false, eObj = {}) {
      let preEventObj = {};
      preEventObj = {
        category: "cheesy rewards",
        actionType: "crosstap",
        ...eObj,
      };  
      
      let eventType = isClicked ? "CR_Click" : "Impression";
      let userAction = isClicked ? "Click" : "Impression";
      const eventObj = Utility.amplitudeEventObj(
        userAction, 
        "menu enrollment strip", 
        "", 
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    closeSbw() {
      this.eventFunCloseSbw(true, { Page_Name: PageNames.NEXTGEN_MENUPAGE, Previous_page: PageNames.NEXTGEN_HOMEPAGE });
      Utility.setSessionStorageValue("showSlidingBanner", true);
      this.sbwShowOnce = false;
    },
    tryAgain() {
      this.retryCount++;
      this.closeWidgetModal();
    },
  },
  computed: {
    checkBoostAvail() {
      let bwObj = this.getUserData?.boostWeekRes;
      const objKey = "multiplier";

      if(this.widgetSubType != 'loyalty') {
        return true;
      } else {
        if (Utility.isKeyAvailAndObjNotEmpty(bwObj, objKey)) {
          return bwObj[objKey];
        } else {
          return false;
        }
      }
    },
    checkSbwShowOnce() {
      if (!Utility.getSessionStorageValue("showSlidingBanner")) {
        return this.sbwShowOnce;
      }
    },
    isLoadingWidgetAPI() {
      return this.$store.state.User.isLoadingWidgetAPI;
    },
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    getWidgetData() {
      const {type} = this.modulePropsData
      let tempData = this.$store.state.User?.staticWidgetData;
      let key = type ? type : "";
      let data = [];
      if (key) {
        data = tempData[key] || [];
      }
      return data;
    },
    getUserData() {
      return this.$store.getters[keyMapsGetter.GET_USER_DATA];
    },
    isLoading() {
      return this.$store.state.User.isLoading;
    },
    isEnrollmentSuccess() {
      return this.$store.state.User.enrollmentSuccess;
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
  },
};
</script>
